/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { BehaviorSubject } from 'rxjs';
import { ExpressionManager, FormDefinitionWrapper, NIFormData } from '../react/components/form/services';

export function getListItemValues(
  formData: NIFormData,
  form: FormDefinitionWrapper | null
): {
  primary: string | null;
  secondary: string | null;
} {
  if (!form)
    return {
      primary: null,
      secondary: null,
    };

  const expMgr = new ExpressionManager(new BehaviorSubject<NIFormData>(formData));
  const listing = form!.definition.render.listing;
  let primary = null, secondary = null;
  expMgr
    .watch(listing.primaryLabel, '')
    .subscribe((out) => {
      primary = out! as string;
    })
    .unsubscribe();
  if (listing.secondaryLabel) {
    expMgr
      .watch(listing.secondaryLabel, '')
      .subscribe((out) => {
        secondary = out! as string;
      })
      .unsubscribe();
  }

  expMgr.complete();
  return { primary, secondary };
}
